<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <CRow>
                <CCol >
                    <h1 class="page__title">{{ $t("Headers") }}</h1>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow
                    v-show="
                        hasItemsInTable({
                            tableName: 'tags',
                        })
                    "
                >
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <CRow>
                                    <CCol>
                                        <h1 class="page__title">{{ $t("Tags") }}</h1>
                                    </CCol>
                                </CRow>
                            </CCardHeader>
                            <CCardBody>
                                <CRow class="border-bottom">
                                    <CCol >
                                        <CBreadcrumb class="background-full-white" :items="breadItems"/>
                                    </CCol>
                                </CRow>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.tags.items"
                                    :fields="traslateArrayObjects({ 
                                        array:tables.tags.fields,
                                        fields:['label']
                                    })"
                                    :itemsPerPageSelect="{
                                        values:[5, 10, 20],
                                    }"
                                    :columnFilterValue.sync="tables.tags.columnFilterValue"
                                    @update:column-filter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="tables.tags.rows"
                                    v-bind="tables.tags"
                                >
                                    <template #id="{ item }" >
                                        <td>
                                            {{ item.id }}
                                        </td>
                                    </template>
                                    <template #name="{ item }" >
                                        <td>
                                            <a  class="bread-ancord"
                                                @click="
                                                    $router.push({
                                                        name: 'tag_fields',
                                                        query: { 
                                                            uuid: item.uuid
                                                        },
                                                    })
                                                "
                                            >
                                                {{item.name}}
                                            </a>
                                        </td>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter
                                v-if="tables.tags.total_pages > 0"
                            >
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="tables.tags.page"
                                        :pages="tables.tags.total_pages"
                                        align="center"
                                    />
                                    <CElementCover :opacity="0.8" class="bg-trasparent" v-if="tables.tags.loading"/>
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
            <NoItemsContainer
                v-show="
                    !hasItemsInTable({
                        tableName: 'tags'
                    })
                "
            >
                <template #title>
                    {{ 'Not tags found' }}
                </template>
                <template #description>
                    {{ $t("No tags have been found") }}
                </template>
                <template #cleanFilter>
                    <CButton
                        color="primary"
                        class="button"
                        v-show="
                            hasFiltersInTable({
                                tableName: 'tags' 
                            })
                        "
                        @click="cleanFiltersAdvance('tags'), updateData()"
                    >
                        <span class="button__icon">
                            <CIcon
                                :content="$options.icons.eraser"
                            />
                        </span>
                        <span class="button__text">
                            {{ $t("Clean filters") }}
                        </span>
                    </CButton>
                </template>
            </NoItemsContainer>
        </CCardBody>
    </CCard>
  
</template>

<script>
import FilterDate from "~/components/FilterDate";
import NoItemsContainer from "~/components/NoItemsContainer";
import { cilPlus, cilSettings, cilReload, cilPencil, cilChart , cilTrash, cilArrowThickFromRight, cilMediaPlay, cilMediaStop } from '@coreui/icons';
import { eraser }  from '~/assets/icons/js/eraser';
import pageMixin from '~/mixins/page.js';
import tableMixin from '~/mixins/table.js';
import TagTable from './Config/Tables/tags.js';
export default {
    name:"TagsPage",
    middleware: ["auth","page"],
    mixins: [ pageMixin, tableMixin ],
    components:{
        FilterDate,
        NoItemsContainer
    },
    icons:{
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilArrowThickFromRight,
        cilReload,
        cilChart,
        cilMediaPlay,
        cilMediaStop,
        eraser
    },
    data(){
        return{
            tables:{
                tags:TagTable
            },
            breadItems:[
                {
                    text: 'Tags'
                }
            ],
            breadItemsFields:[
                {
                    text: 'Fields'
                }
            ],
            activity:[],
            intervalActivity:null
        }
    },
    methods:{
        itemPerPage(newValue){
            this.tables.tags.rows = newValue;
            this.updatePagination(this.tables.tags.page);
        },
        updatePagination(newValue){
            this.tables.tags.page = newValue;
            this.updateData();
        },
        async updateData(){
            await this.updateTable({
                tableName:"tags", 
                url:'/tags',
                fetch:{
                    baseURL: process.env.VUE_APP_API_CORE,
                },
                adapterFilters: (filters)=>{
                    delete filters.where.created_at
                    return filters;
                }
            });
            this.tables.tags.loading = false;
            this.updatePageLoading(false);
        }
    },
    async mounted(){
        await this.updateData();
    }
}
</script>

<style scoped lang="scss">
    /* .request-report{
        overflow: hidden;
        width: 30%;
    }
    .message{
        width: 30%;
        overflow: hidden;
    } */
    .background-full-white{
        background-color: #fff;
        border-color: #fff;
    }
    .bread-ancord{
        color:#007bff;
        cursor:pointer;
    }
    .message__container{
        overflow: hidden;
    }

    .pre{
        & .pre__container{
            max-width: 30rem;
            overflow: auto;
            & .span__pre {
                display: block;
                unicode-bidi: embed;
                font-family: monospace;
                /* white-space: pre; */
                white-space: pre-wrap;
            }
        }
        
    }
    
    
</style>